"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_TRACE_ID_KEY = exports.PERMISSION_BASED_MFES = exports.CustomerFeatures = exports.SegmentDimensions = exports.BarChartDimensions = exports.AttibuteLabelLineHight = void 0;
var AttibuteLabelLineHight = /** @class */ (function () {
    function AttibuteLabelLineHight() {
    }
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_1_LINE_HEIGHT = 32;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_2_LINES_HEIGHT = 48;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_3_LINES_HEIGHT = 64;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_4_LINES_HEIGHT = 80;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_5_LINES_HEIGHT = 96;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_6_LINES_HEIGHT = 128;
    AttibuteLabelLineHight.ATTRIBUTE_LABEL_MORE_THAN_6_LINES_HEIGHT = 144;
    return AttibuteLabelLineHight;
}());
exports.AttibuteLabelLineHight = AttibuteLabelLineHight;
var BarChartDimensions = /** @class */ (function () {
    function BarChartDimensions() {
    }
    BarChartDimensions.BAR_CHART_DOM_HEIGHT = 32;
    BarChartDimensions.BAR_CHART_TOP_BORDER = 1;
    BarChartDimensions.BAR_CHART_BOTTOM_PADDING = 4;
    BarChartDimensions.BAR_CHART_BOTTOM_PADDING_LAST = 8;
    return BarChartDimensions;
}());
exports.BarChartDimensions = BarChartDimensions;
var SegmentDimensions = /** @class */ (function () {
    function SegmentDimensions() {
    }
    SegmentDimensions.SEGMENT_WIDTH = 200;
    SegmentDimensions.SEGMENT_MAX_LENGTH_LIMIT = 66;
    return SegmentDimensions;
}());
exports.SegmentDimensions = SegmentDimensions;
var CustomerFeatures = /** @class */ (function () {
    function CustomerFeatures() {
    }
    CustomerFeatures.TV_RF_USER = 'tv_rf_user';
    CustomerFeatures.EMAIL_EXPORTS = 'email_exports';
    CustomerFeatures.CURATOR = 'curator';
    CustomerFeatures.GWIQIE_USER = 'gwiqie_user';
    CustomerFeatures.EXPORT_BLOCKED = 'export_blocked';
    CustomerFeatures.DEVICE_REGISTRATION_EXEMPT = 'device_registration_exempt';
    CustomerFeatures.DEBUG_BUTTONS = 'debug_buttons';
    CustomerFeatures.XB_20_VISIBLE_IN_PRONEXT = 'xb_20_visible_in_pronext';
    CustomerFeatures.XB_50K_TABLE_LIMIT_PRODUCT_ONLY = 'XB 50k Table Limit (Product Only)';
    CustomerFeatures.DASHBOARDS_2_0_VISIBLE_IN_PRO_NEXT = 'Dashboards 2.0 visible in pro-next';
    CustomerFeatures.ADMIN_INSIGHTS_ACCESS = 'Admin - Insights Access';
    CustomerFeatures.P2_INSIGHTS_APP_ACCESS = 'P2 Insights App Access';
    CustomerFeatures.DASHBOARDS_GWI_CREATOR_PRODUCT_ONLY = 'Dashboards GWI creator (Product Only)';
    CustomerFeatures.DASHBOARDS_NON_GWI_CREATOR_PRODUCT_ONLY = 'Dashboards non-GWI creator (Product Only)';
    CustomerFeatures.ADMIN_INTERNAL_AUTHORISATION_ACCESS = 'Admin - Internal Authorisation Access';
    CustomerFeatures.TVRF_2_0_VISIBLE_IN_PRO_NEXT = 'TVRF 2.0 visible in pro-next';
    CustomerFeatures.RMP_PANEL_DASHBOARD_PANEL_USERS_ONLY = 'RMP Panel Dashboard (Panel users only)';
    CustomerFeatures.P2_HIDE_PRO_ACCESS = 'P2_hide_pro_access';
    CustomerFeatures.P2_IS_DEFAULT_PLATFORM = 'P2 is default platform';
    CustomerFeatures.ADMIN_SERVICE_TOKENS_ACCESS = 'Admin - Service Tokens Access';
    CustomerFeatures.XB2_WARNINGS_REDESIGN = 'xb2_warnings_redesign';
    CustomerFeatures.D2_CHART_BROWSER_PRODUCT_ONLY = 'D2 Chart Browser (product only)';
    CustomerFeatures.DASHBOARD_ONLY_EXCl_AUD_CHARTS = 'Dashboard Only (excl. Aud/Charts)';
    CustomerFeatures.AUDIENCE_ACTIVATION_CONNECTIONS = 'Audience Activation (Connections)';
    CustomerFeatures.GLOBAL_SEARCH_ACCESS = 'Global Search';
    CustomerFeatures.PLATFORM_CONFIGURATION_ACCESS = 'Platform Configuration Access';
    CustomerFeatures.PERSONA_CARD_FEATURE_FLAG = 'persona_card';
    CustomerFeatures.SHOW_SHARED_USER_FEATURE_FLAG = 'show_shared_audience_author';
    return CustomerFeatures;
}());
exports.CustomerFeatures = CustomerFeatures;
exports.PERMISSION_BASED_MFES = new Map([
    [
        'free',
        {
            'chart-builder': true,
            crosstabs: false,
            audiences: true,
            dashboards: true,
            'dashboards-react': true,
            'global-search': true,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ],
    [
        'free_reports',
        {
            'chart-builder': true,
            crosstabs: false,
            audiences: true,
            dashboards: true,
            'dashboards-react': true,
            'global-search': true,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ],
    [
        'view_only',
        {
            'chart-builder': true,
            crosstabs: false,
            audiences: true,
            dashboards: true,
            'dashboards-react': true,
            'global-search': false,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ],
    [
        'open_access_view_only',
        {
            'chart-builder': false,
            crosstabs: false,
            audiences: false,
            dashboards: true,
            'dashboards-react': true,
            'global-search': false,
            'tv-rf': false,
            insights: false,
            'account-settings': false,
            home: false,
            header: true
        }
    ],
    [
        'professional',
        {
            'chart-builder': true,
            crosstabs: true,
            audiences: true,
            dashboards: true,
            'dashboards-react': true,
            'global-search': true,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ],
    [
        'student',
        {
            'chart-builder': false,
            crosstabs: false,
            audiences: false,
            dashboards: false,
            'dashboards-react': false,
            'global-search': true,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ],
    [
        'dashboards',
        {
            'chart-builder': true,
            crosstabs: false,
            audiences: true,
            dashboards: true,
            'dashboards-react': true,
            'global-search': true,
            'tv-rf': false,
            insights: true,
            'account-settings': true,
            home: true,
            header: true
        }
    ]
]);
exports.HEADER_TRACE_ID_KEY = 'x-gateway-uuid';
